export const emoji = [
  '😀',
  '😃',
  '😄',
  '😁',
  '😆',
  '😅',
  '😂',
  '🤣',
  '😊',
  '😇',
  '🙂',
  '🙃',
  '😉',
  '😌',
  '😍',
  '😘',
  '😗',
  '😙',
  '😚',
  '😋',
  '😛',
  '😝',
  '😜',
  '🤓',
  '😎',
  '😏',
  '😒',
  '😞',
  '😔',
  '😟',
  '😕',
  '🙁',
  '😣',
  '😖',
  '😫',
  '😩',
  '😢',
  '😭',
  '😤',
  '😠',
  '😡',
  '😳',
  '😱',
  '😨',
  '🤗',
  '🤔',
  '😶',
  '😑',
  '😬',
  '🙄',
  '😯',
  '😴',
  '😷',
  '🤑',
  '😈',
  '🤡'
]
